export const emoji = [
  '😀',
  '😃',
  '😄',
  '😁',
  '😆',
  '😅',
  '😂',
  '🤣',
  '😊',
  '😇',
  '🙂',
  '🙃',
  '😉',
  '😌',
  '😍',
  '😘',
  '😗',
  '😙',
  '😚',
  '😋',
  '😛',
  '😝',
  '😜',
  '🤓',
  '😎',
  '😏',
  '😒',
  '😞',
  '😔',
  '😟',
  '😕',
  '🙁',
  '😣',
  '😖',
  '😫',
  '😩',
  '😢',
  '😭',
  '😤',
  '😠',
  '😡',
  '😳',
  '😱',
  '😨',
  '🤗',
  '🤔',
  '😶',
  '😑',
  '😬',
  '🙄',
  '😯',
  '😴',
  '😷',
  '🤑',
  '😈',
  '🤡'
]
